import {
  SIGN_IN_WITH_EMAIL,
  SIGN_IN_WITH_EMAIL_SUCCESS,
  SIGN_IN_WITH_EMAIL_ERROR,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
} from '../actions';

import { getCurrentUser } from '../../helpers/Utils';
import { isAuthGuardActive, currentUser } from '../../constants/defaultValues';

const INIT_STATE = {
  currentUser: isAuthGuardActive ? currentUser : getCurrentUser(),
  loading: false,
  loadingSubmit: false,
  error: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGN_IN_WITH_EMAIL:
      return { ...state, loading: true };
    case SIGN_IN_WITH_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        currentUser: action.payload,
        error: '',
      };
    case SIGN_IN_WITH_EMAIL_ERROR:
      return {
        ...state,
        loading: false,
        currentUser: null,
        error: action.payload
      };
    case FORGOT_PASSWORD:
      return { ...state, loading: true };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case RESET_PASSWORD:
      return { ...state, loading: true };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return { ...state };
  }
};
